import { createReducer } from 'redux-act';

import {
  finishInfoRequest,
  finishInfoSuccess,
  finishInfoFail,
  finishInfoSendRequest,
  finishInfoSendSuccess,
  finishInfoSendFail,
} from './finishInfo.actions';

export interface IFinishInfoState {
  isLoading: boolean;
  message: string;
  isAnswerSending: boolean;
  isAnswerSent: boolean;
  errors: {};
}

export const initialState: IFinishInfoState = {
  isLoading: false,
  message: '',
  isAnswerSending: false,
  isAnswerSent: false,
  errors: {},
};

const reducer = createReducer<IFinishInfoState>({}, initialState);

reducer
  .on(finishInfoRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(finishInfoSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    message: payload.message,
  }))
  .on(finishInfoFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(finishInfoSendRequest, state => ({
    ...state,
    isAnswerSending: true,
  }))
  .on(finishInfoSendSuccess, state => ({
    ...state,
    isAnswerSending: false,
    isAnswerSent: true,
  }))
  .on(finishInfoSendFail, (state, payload) => ({
    ...state,
    isAnswerSending: false,
    errors: payload,
  }));

export default reducer;
